<div class="mt-4">
  <p-progress-bar [value]="currentProgress()"> </p-progress-bar>

  <div class="w-100 d-flex align-items-center justify-content-between mt-4">
    <div class="text-nowrap">
      {{
        'pages.transport.tracking-list.export-dialog.downloaded-x-out-of-y-bytes'
          | translate: { curr: currentBytes() | byteFormat, total: estimatedMaxBytes() | byteFormat }
      }}
    </div>
  </div>

  <div class="w-100 d-flex align-items-center mt-4">
    <p-button (onClick)="cancelExport()" [label]="'general.cancel' | translate"></p-button>
  </div>
</div>
